import { ICONS, type IconName } from './registry.ts';

export interface IconProps {
  readonly name: IconName;
  /**
   * Thiết kế dùng 9 cỡ cho 74 icon: 12(×2) 13(×9) 14(×2) 15(×15) 16(×4) 17(×12) 18(×12) 19(×13)
   * 20(×5) — không cỡ nào chiếm quá 20%. Mặc định 15 vì đó là cỡ đếm được nhiều nhất, nhưng với
   * phân bố phẳng như vậy thì gần như chỗ nào cũng nên truyền `size` đọc thẳng từ thiết kế.
   */
  readonly size?: number;
  /**
   * Đặt label CHỈ khi icon là thông tin duy nhất (ví dụ nút đóng không có chữ). Icon đi kèm chữ
   * thì để trống, vì screen reader đọc lại nhãn là nhiễu.
   */
  readonly label?: string;
  readonly className?: string;
}

/**
 * Màu KHÔNG phải prop: lucide vẽ bằng `currentColor`, nên chỗ dùng đặt màu bằng class token trên
 * chính nó hoặc trên thẻ cha. Thêm một prop màu ở đây là mở đường cho hex đi vòng qua cổng
 * `check-classes`.
 *
 * `aria-hidden` khai TƯỜNG MINH dù bản lucide hiện tại cũng tự thêm khi không có prop a11y nào:
 * hành vi mặc định đó là chi tiết cài đặt của thư viện, còn đây là hợp đồng của ta.
 */
export function Icon({ name, size = 15, label, className }: IconProps) {
  const Glyph = ICONS[name];
  return (
    <Glyph
      size={size}
      className={className}
      {...(label === undefined ? { 'aria-hidden': true } : { role: 'img', 'aria-label': label })}
    />
  );
}
